/**
 * Contato e suporte (§21.12).
 *
 * SEM PROMESSA DE PRAZO QUE NINGUÉM ASSUMIU. "Respondemos em 24 horas" numa
 * página pública é uma obrigação criada por quem escreveu a página, e cobrada de
 * quem atende. Aqui dizemos o caminho e o que ajuda a acelerar — não um relógio.
 *
 * Também não há formulário: um formulário que só envia para o vazio é pior do
 * que um endereço de e-mail honesto.
 */

import { Link } from 'react-router-dom';
import { BRANDING } from '../config/branding';
import { RodapePublico } from '../components/RodapePublico';
import { t } from '../lib/i18n';

export function ContatoPage(): JSX.Element {
  return (
    <div className="mx-auto min-h-screen max-w-3xl px-4 py-10">
      <h1 className="text-2xl font-semibold text-ink">{t('contato.titulo')}</h1>
      <p className="mt-2 text-sm text-ink-muted">
        O {BRANDING.productName} é um produto {BRANDING.company}.
      </p>

      <section className="mt-6">
        <h2 className="text-sm font-semibold text-ink">{t('contato.jaUsa')}</h2>
        <p className="mt-2 text-xs text-ink-muted">{t('contato.faleAdministrador')}</p>
      </section>

      <section className="mt-6">
        <h2 className="text-sm font-semibold text-ink">{t('contato.falarBugKillers')}</h2>
        <p className="mt-2 text-xs text-ink-muted">
          Escreva para{' '}
          <a className="text-brand-700 underline" href="mailto:tecnologia@bugkillers.net">
            tecnologia@bugkillers.net
          </a>
          .
        </p>
        <p className="mt-2 text-xs text-ink-muted">{t('contato.ajudaResolver')}</p>
        <ul className="mt-1 space-y-1 text-xs text-ink-muted">
          <li>{t('contato.oQueTentou')}</li>
          <li>a tela e o horário aproximado;</li>
          <li>{t('contato.codigoCurto')}</li>
        </ul>
      </section>

      <section className="mt-6">
        <h2 className="text-sm font-semibold text-ink">{t('contato.segurancaPrivacidade')}</h2>
        <p className="mt-2 text-xs text-ink-muted">
          Para relatar uma vulnerabilidade ou exercer direitos sobre dados pessoais, use o mesmo
          endereço e diga isso no assunto — esses pedidos têm tratamento próprio, descrito nos{' '}
          <Link to="/legal" className="text-brand-700 underline">
            documentos legais
          </Link>
          .
        </p>
      </section>

      <RodapePublico />
    </div>
  );
}
